<!--使用指南-->
<template>
  <div class="use-box fs18 ">
    <!--    <div class="dialog-video">-->
    <!--      <video ref="videoPlayer" style="width: 100%;height: 100%" controls="" :autoplay="false" src="https://oss.xingchaoyiqing.com/guide/guide-cross.mp4"></video>-->
    <!--    </div>-->
    <div class="all-js-box">
      <div class="flex ac fw">
        <div class="erery-js cr" v-for="(item,index) in jsList" :key="index" :style="{ color: choosedIndex==index? theme.useColor4 : theme.homeColor4, backgroundColor: choosedIndex==index ? theme.useColor3 : theme.useColor1}"
               @click="handleChoose(index)">
          <div class="">{{item.name}}</div>
        </div>
      </div>
    </div>
    <div class="all-guide flex ac fw cr">
      <div class="every-guide" @click="handlePlay(item)" v-for="(item,index) in guideVideoList" :key="index">
        <img :src="item.cover" mode="aspectFit"></img>
        <div class="pp-title te" :style="{ color: theme.useColor5 }">{{item.name}}</div>
      </div>
    </div>
    <el-dialog
      :title="videoName"
      :visible.sync="dialogVisible"
      width="50%"
      @close="handleDialogClose"
    >
      <div class="dialog-video">
        <video ref="videoPlayer" style="width: 100%;height: 100%" controls="" autoplay="" :src="videoUrl"></video>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import {gguide} from '../api/user'

  export default {
    name: '',
    computed: {
      theme() {
        return this.$store.getters.getTheme;
      }
    },
    data() {
      return {
        jsList: [],
        guideVideoList: [],
        choosedIndex: 0,
        videoName: '',
        videoUrl: '',
        dialogVisible: false
      }
    },
    created() {
      this.getGguide()
    },
    methods: {
      handleChoose(index) {
        this.choosedIndex = index
        this.guideVideoList = this.jsList[index].list ? this.jsList[index].list : []
      },
      getGguide() {
        gguide().then(res => {
          this.jsList = res.data
          this.guideVideoList = this.jsList[0].list ? this.jsList[0].list : []
        })
      },
      handleDialogClose() {
        // 停止视频播放
        if (this.$refs.videoPlayer) {
          this.$refs.videoPlayer.pause();
        }
      },
      handlePlay(item) {
        this.videoName = item.name
        this.videoUrl = item.video_url
        this.dialogVisible = true
      },
    },
    /**加载完组件时执行(加载完成之后执行)*/
    mounted() {
    },
  }
</script>

<style lang="scss" scoped>
  p {
    margin: 0;
  }
  .use-box::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }
  .use-box {
    box-sizing: border-box;
    width: 100%;
    padding: 24px;
    height: calc(100vh - 50px);
    overflow-y: scroll;
    overflow-x: hidden;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    border-radius: 12px;

    .dialog-video {
      width: 100%;
      height: 440px;
    }
  }
  .all-js-box{
    width: 100%;
    margin: 0 auto 25px;
    .erery-js{
      width: 79px;
      height: 32px;
      background: rgba(255,255,255,0.1);
      border-radius: 6px;
      border: 1px solid rgba(255,255,255,0.15);
      line-height: 32px;
      font-weight: 400;
      font-size: 13px;
      color: #FAFAFAAA;
      text-align: center;
      margin-right: 15px;
    }
    .active{
      background: #6C14FF;
      font-size: 13px;
      color: #FAFAFA;
    }
  }
  .all-guide{
    width: 100%;
    margin: 0 auto;
    .every-guide{
      width: 243px;
      flex-shrink: 0;
      margin: 0 36px 15px 0;
      img{
        width: 243px;
        height: 323px;
        object-fit: cover;
        border-radius: 5px;
      }
      .pp-title{
        width: 100%;
        font-weight: 400;
        font-size: 15px;
        color: #EEEEEEAA;
        text-align: center;
        margin: 12px auto 16px;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/use.vue